import { API_URL_HACKATAO_CLAIM_TRAIT } from "@constants/Clients/hackatao/hackatao.env";
import apiInstance from "@services/Shared/instanceAxios";

const deleteItem = (uuid: string) =>
  apiInstance({
    url: API_URL_HACKATAO_CLAIM_TRAIT + uuid,
    method: "delete",
  });

export default deleteItem;
